<template>
  <div>
    <veaDialog
      title="每月目标"
      class="monthMBTable"
      :show.sync="show"
      :before-close="closeDialog"
      :footer="false"
    >
      <div class="tool">
        <el-form ref="form" :model="form" label-width="60px">
          <el-row :gutter="5">
            <el-col :span="3">
              <el-form-item label="月份">
                <el-select
                  clearable
                  v-model="yymm"
                  placeholder="请选择月份"
                  @change="_Query_tpr_monthMB()"
                >
                  <el-option
                    v-for="item in yymmArr"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-input
                v-model="str"
                placeholder="合同关键字"
                @input="selectData"
              ></el-input>
            </el-col>
            <el-col :span="1">
              <el-button
                type="primary"
                size="small"
                class="search"
                @click="addM()"
              >
                新增
              </el-button>
            </el-col>
            <el-col :span="3">
              <el-select
                v-model="username"
                placeholder="请选择"
                @change="_Query_tpr_monthMB"
                v-show="mglist.length"
              >
                <el-option
                  v-for="item in mglist"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2"> 团队完成率{{ av }}% </el-col>
            <el-col :span="1">
              <el-button
                type="info"
                size="small"
                class="search"
                @click="print()"
              >
                打印
              </el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <el-table
        ref="table"
        border
        stripe
        v-loading="tableload"
        highlight-current-row
        :data="tableData"
        tooltip-effect="dark"
        header-row-class-name="table_header"
        :header-row-style="{ 'text-align': 'center' }"
        @selection-change="handleSelectionChange"
        style="width: 100%"
        height="80vh"
        :row-class-name="tableRowClassName"
        :cell-class-name="tableCellClassName"
      >
        <el-table-column
          v-for="(item, i) in th"
          :key="i"
          :label="item.chnname"
          :width="item.width"
          :align="item.align || 'center'"
          show-overflow-tooltip
          sortable
        >
          <template slot-scope="scope">
            <template v-if="scope.row.isEdit && !item.isreadonly">
              <el-switch
                v-if="item.switch"
                :disabled="item.disabled"
                v-model="scope.row[item.fieldname]"
                active-color="#1890FF"
                inactive-color="#999999"
              ></el-switch>
              <el-select
                clearable
                v-else-if="item.select"
                v-model="scope.row[item.fieldname]"
                placeholder="请选择状态"
              >
                <el-option
                  v-for="item in tboptions[item.op || item.fieldname]"
                  :key="item.autoid"
                  :label="item.name + '-' + item.ctname"
                  :value="item.autoid"
                >
                </el-option>
              </el-select>
              <el-input
                v-else-if="item.number"
                v-model="scope.row[item.fieldname]"
                oninput="value=value.replace(/\D/g,'')"
              />
              <el-date-picker
                v-else-if="item.datetime"
                type="date"
                placeholder="选择日期"
                v-model="scope.row[item.fieldname]"
                style="width: 100%;"
              ></el-date-picker>
              <el-input v-else v-model="scope.row[item.fieldname]" />
            </template>

            <div style="white-space: pre-wrap" v-else>
              {{
                item.switch
                  ? scope.row[item.fieldname]
                    ? '是'
                    : '否'
                  : item.select
                  ? scope.row['name'] + '-' + scope.row['ctname']
                  : scope.row[item.fieldname]
              }}
            </div>
          </template>
        </el-table-column>
        <!-- 项目明细 -->
        <el-table-column
          :label="'项目明细'"
          width="100"
          fixed="right"
          class-name="operateColumn"
        >
          <template slot-scope="scope">
            <span
              @click="
                action2(
                  scope.row.mautoid,
                  1,
                  scope.row['name'] + '-' + scope.row['ctname']
                )
              "
            >
              已完成
            </span>
            <span class="divid">|</span>
            <span
              @click="
                action2(
                  scope.row.mautoid,
                  2,
                  scope.row['name'] + '-' + scope.row['ctname']
                )
              "
            >
              未完成
            </span>
            <span class="divid">|</span>
            <span
              @click="
                action2(
                  scope.row.mautoid,
                  3,
                  scope.row['name'] + '-' + scope.row['ctname']
                )
              "
            >
              所有
            </span>
          </template>
        </el-table-column>
        <!-- 操作 -->
        <el-table-column
          :label="'操作'"
          width="200"
          fixed="right"
          class-name="operateColumn"
        >
          <template slot-scope="scope">
            <span
              class="table_operate"
              :title="scope.row.isEdit ? '保存' : '删除'"
              @click="
                tableOperate(
                  scope.$index,
                  scope.row,
                  scope.row.isEdit ? 'save' : 'delete'
                )
              "
            >
              <svg-icon
                :icon-class="
                  scope.row.isEdit ? 'advancedQuerySave' : 'advancedQueryDelete'
                "
              />
            </span>
            <span class="divid">|</span>
            <span
              class="table_operate"
              :title="scope.row.isEdit ? '取消编辑' : '编辑'"
              @click="
                tableOperate(
                  scope.$index,
                  scope.row,
                  scope.row.isEdit ? 'cancel' : 'edit'
                )
              "
            >
              <svg-icon
                :icon-class="
                  scope.row.isEdit ? 'advancedQueryCancel' : 'advancedQueryEdit'
                "
              />
            </span>
            <span class="divid">|</span>
            <span @click="action(scope.row.mautoid, 1)"> 周报 </span>
            <span class="divid">|</span>
            <span @click="action(scope.row.mautoid, 2)"> 调研报告 </span>
            <span class="divid">|</span>
            <span @click="action(scope.row.mautoid, 3)"> 上线报告 </span>
            <span class="divid">|</span>
            <span @click="action(scope.row.mautoid, 4)"> 培训签到表 </span>
            <span class="divid">|</span>
            <span @click="action(scope.row.mautoid, 5)"> 验收报告 </span>
          </template>
        </el-table-column>
      </el-table>
    </veaDialog>

    <veaDialog
      :title="'新增每月目标'"
      class="reCHForm"
      :show.sync="showFrom"
      :before-close="closeDialog2"
    >
      <monthMBForm ref="monthMBForm" :tboptions="tboptions" />
    </veaDialog>
    <filelist ref="filelist" :ty="'0'" :choos="choos" :pautoid="pautoid" />
    <zhoubao ref="zb" :pautoid="pautoid" />
    <veaDialog
      :title="'项目进度'"
      class="jdtable"
      :show.sync="jsshow"
      :before-close="closeDialog3"
      :footer="false"
    >
      <el-table
        ref="table2"
        border
        stripe
        v-loading="tableload"
        highlight-current-row
        :data="tableData2"
        tooltip-effect="dark"
        header-row-class-name="table_header"
        :header-row-style="{ 'text-align': 'center' }"
        @selection-change="handleSelectionChange"
        @row-dblclick="handRowdbClick"
        style="width: 100%"
        height="90vh"
      >
        <el-table-column
          v-for="(item, i) in th2"
          :key="i"
          :label="item.chnname"
          :width="item.width"
          :align="item.align || 'center'"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span>{{
              item.datetime && scope.row[item.fieldname]
                ? scope.row[item.fieldname].split('T')[0]
                : item.switch
                ? scope.row[item.fieldname]
                  ? '是'
                  : '否'
                : scope.row[item.fieldname]
            }}</span>
          </template>
        </el-table-column>
      </el-table>
    </veaDialog>
    <!-- 进度 -->
    <veaDialog
      :title="'项目进度'"
      class="reForm"
      :show.sync="showre"
      :footer="false"
    >
      <el-form ref="form" :model="formjd" label-width="100px">
        <el-row>
          <el-col :span="6">
            <el-form-item label="所属阶段" :required="true">
              <el-select
                clearable
                v-model="formjd.phase"
                placeholder="请选择所属阶段"
              >
                <el-option
                  v-for="item in tboptions.phase"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="模块分类" :required="true">
              <el-select
                clearable
                v-model="formjd.name"
                placeholder="请选择模块分类"
              >
                <el-option
                  v-for="item in tboptions.name"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <progressForm ref="progressForm" :tboptions="tboptions" />
    </veaDialog>
  </div>
</template>

<script>
import {
  Query_tpr_monthMB,
  Edit_tpr_monthMB,
  Query_tpr_monthMB_detail,
  GetProject,
  GetEmplist,
  GetMBRp,
  Query_tpr_xm_jd
} from '@api/api.js'
import monthMBForm from '@components/monthMBForm.vue'
import filelist from '@components/filelist.vue'
import zhoubao from '@components/zhoubao.vue'
import progressForm from '@components/progressForm.vue'
import { parseTime } from '@/utils'
export default {
  components: {
    monthMBForm,
    filelist,
    zhoubao,
    progressForm
  },
  data() {
    return {
      userInfo: JSON.parse(sessionStorage.userInfo) || {},
      show: false,
      showFrom: false,
      jsshow: false,
      form: {},
      yymm: parseTime(new Date(), '{y}{m}'),
      av: 0,
      th: [
        {
          chnname: '项目名称',
          fieldname: 'mautoid',
          width: '200',
          select: true
        },

        {
          chnname: '工程师',
          fieldname: 'crman',
          width: '80',
          isreadonly: true
        },
        {
          chnname: '计划实施人天',
          fieldname: 'jh_ssrt',
          width: '120',
          isreadonly: true
        },
        {
          chnname: '已实施人天',
          fieldname: 'ssrt',
          width: '120',
          isreadonly: true
        },
        {
          chnname: '预计结案时间',
          fieldname: 'yj_enddate',
          width: '120',
          isreadonly: true
        },
        {
          chnname: '合同开始时间',
          fieldname: 'cbd',
          width: '120',
          isreadonly: true
        },
        {
          chnname: '考核内容',
          fieldname: 'contanttotal',
          width: '100',
          align: 'left'
        },
        {
          chnname: '实际完成情况',
          width: '120',
          fieldname: 'conditiontotal'
        },
        {
          chnname: '是否完成',
          width: '100',
          fieldname: 'finshintotal'
        },
        {
          chnname: '本月完成率',
          width: '120',
          fieldname: 'wcl'
        },
        {
          chnname: '项目完成率',
          width: '120',
          fieldname: 'jd'
        },
        {
          chnname: '预计结案日期',
          fieldname: 'yj_jadate',
          width: '120',
          isreadonly: true
        },
        {
          chnname: '实际结案日期',
          fieldname: 'sj_jadate',
          width: '120',
          isreadonly: true
        },
        {
          chnname: '考核得分',
          width: '100',
          fieldname: 'cost'
        }
      ],
      initData: [], //保存表格接口返回的原始数据
      tableData: [],
      tableload: false,
      tablerow: {},
      curRow: {}, // 修改中的行
      tableChange: true,
      tboptions: {
        mautoid: []
      },
      str: '',
      mglist: [],
      username: '',
      choos: { id: 0, name: '' },
      pautoid: '',
      th2: [
        {
          chnname: '所属模块',
          fieldname: 'module',
          width: '80',
          readonly: true,
          fixed: 'left'
        },
        {
          chnname: '任务序号',
          fieldname: 'sqnum',
          width: '80',
          fixed: 'left'
        },
        {
          chnname: '审核状态',
          fieldname: 'shzt',
          width: '80',
          readonly: true,
          fixed: 'left'
        },
        {
          chnname: '类型',
          fieldname: 'type',
          width: '80',
          select: true,
          fixed: 'left'
        },
        {
          chnname: '任务明细',
          fieldname: 'taskdetail',
          width: '80',
          memo: true,
          fixed: 'left'
        },
        {
          chnname: '任务说明',
          fieldname: 'instructions',
          width: '200',
          memo: true
        },
        {
          chnname: '周',
          fieldname: 'week',
          width: '40',
          number: true
        },
        {
          chnname: '计划开始日期',
          fieldname: 'bd',
          width: '130',
          datetime: true
        },
        {
          chnname: '计划结束日期',
          fieldname: 'ed',
          width: '130',
          datetime: true
        },
        {
          chnname: '持续天数',
          fieldname: 'days',
          width: '100',
          number: true
        },
        {
          chnname: '实际完成日期',
          fieldname: 'findate',
          width: '130',
          datetime: true
        },
        {
          chnname: '状态',
          fieldname: 'status',
          width: '100',
          select: true
        },
        {
          chnname: '延期原因',
          fieldname: 'reason',
          width: '200',
          memo: true
        },
        {
          chnname: '负责人',
          fieldname: 'fzr',
          width: '100'
          // select: true
        },
        {
          chnname: '需要研发协助',
          fieldname: 'kf',
          width: '100',
          switch: true
        }
      ],
      tableData2: [],
      formjd: {},
      showre: false
    }
  },
  computed: {
    yymmArr() {
      let arr = [],
        lastMonth = new Date()
      lastMonth.setMonth(lastMonth.getMonth() + 2)
      for (let index = 0; index < 24; index++) {
        lastMonth.setMonth(lastMonth.getMonth() - 1)
        arr.push(parseTime(lastMonth, '{y}{m}'))
      }

      return arr
    }
  },
  watch: {
    show(val) {
      if (val) {
        this.username = this.userInfo.name
        this._GetEmplist()
        this._Query_tpr_monthMB()
      }
    }
  },
  methods: {
    // 在职的技术、开发、售后员工
    _GetEmplist() {
      GetEmplist().then(res => {
        const arr = res.list.map(e => {
          return e.empname
        })
        this._GetProject(arr)
      })
    },
    _GetProject(empname) {
      GetProject({ name: this.userInfo.name }).then(res => {
        this.tboptions.mautoid = res.list
        // 遍历下属 总监默认萧雄清可以看到全部人员
        let ServiceMan = [],
          ServiceMan2 = [],
          ServiceMan3 = [],
          arr = [this.userInfo.name]
        ServiceMan = this.getArr(res.list, 'ServiceMan')
        ServiceMan2 = this.getArr(res.list, 'ServiceMan2')
        ServiceMan3 = this.getArr(res.list, 'ServiceMan3')
        arr = [...arr, ...ServiceMan, ...ServiceMan2, ...ServiceMan3]
        // 去重

        arr = Array.from(new Set(arr))
        this.mglist = arr.filter(item => {
          return empname.includes(item)
        })
        // console.log(this.mglist, 'this.mglist')
      })
    },
    // 返回可见工程师数组
    getArr(data, key) {
      return data
        .filter(e => {
          return (
            (e.Service_Manager == this.userInfo.name ||
              this.userInfo.name == '萧雄清' ||
              this.userInfo.name == '黄桥') &&
            e[key] &&
            e[key] != this.userInfo.name
          )
        })
        .map(e => {
          return e[key]
        })
    },
    _Query_tpr_monthMB() {
      this.initData = []
      this.tableData = []
      Query_tpr_monthMB({
        yymm: this.yymm,
        crman: this.username
      }).then(res => {
        if ((res.error = '0')) {
          let sum = 0
          res.list.forEach(e => {
            e.isEdit = false
            e.cbd = e.cbd.split('T')[0]
            e.yj_jadate = e.yj_jadate ? e.yj_jadate.split('T')[0] : ''
            e.sj_jadate = e.sj_jadate ? e.sj_jadate.split('T')[0] : ''
            sum += e.wcl
          })
          this.av = res.list.length > 0 ? (sum / res.list.length).toFixed(2) : 0
          this.initData = JSON.parse(JSON.stringify(res.list))
          this.tableData = res.list
        } else {
          this.initData = []
          this.tableData = []
        }
      })
    },
    selectData() {
      this.tableData = this.initData.filter(e => {
        return e.ctname.indexOf(this.str) > -1
      })
    },
    closeDialog() {
      this.show = false
    },
    handleSizeChange(val) {
      this.pageSize = val
    },
    handleCurrentChange(val) {
      this.currentPage = val
    },

    // 表格 操作方法
    tableOperate(index, row, type) {
      console.log('tableOperate', { index, row, type })
      // 编辑
      if (type == 'edit') {
        this.showFrom = true
        row.isactive = '1'
        row.isadd = '0'
        Query_tpr_monthMB_detail({ autoid: row.autoid }).then(res => {
          this.$refs.monthMBForm.form = row
          this.$refs.monthMBForm.detail = res.list
        })
        // row.isEdit = true
        // this.$forceUpdate()
      } else if (type == 'cancel') {
        row.isEdit = false
        // 还原数据: 刷选上次接口返回的数据
        this.initData.forEach(el => {
          if (row.autoid == el.autoid) {
            let obj = JSON.parse(JSON.stringify(el))
            Object.assign(row, obj)
            this.$forceUpdate()
          }
        })
      } else if (type == 'save') {
        // 修改
        row.isactive = 1
        row.isadd = false
        Edit_tpr_monthMB(row).then(res => {
          this.$message.success('修改成功')
          row.isEdit = false
          this._Query_tpr_monthMB() // 获取列表
        })
      } else if (type === 'delete') {
        // 删除
        this.$confirm('您确定更要删除该记录吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          row.isEdit = false
          Edit_tpr_monthMB({
            autoid: row.autoid,
            isactive: 0,
            isadd: false
          }).then(res => {
            this.$message.success('删除成功')
            this._Query_tpr_monthMB() // 获取列表
          })
        })
      }
    },
    handleSelectionChange(val) {
      this.tableChange = val
    },
    // 添加每月目标
    addM() {
      this.showFrom = true
      this.$nextTick(() => {
        this.$refs.monthMBForm.form = {
          crman: this.username,
          autoid: 0,
          yymm: this.yymm,
          contant: '',
          condition: '',
          cost: '',
          mautoid: null,
          isactive: '1',
          isadd: '1'
        }
        this.$refs.monthMBForm.detail = []
      })
    },
    // 关闭变更记录
    closeDialog2(a) {
      if (a == 'confirm') {
        // 保存
        let form = this.$refs.monthMBForm.form
        let detail = this.$refs.monthMBForm.detail
        if (form.mautoid) {
          if (form.autoid) {
            detail.forEach(e => {
              e.mautoid = form.autoid
            })
          }
          form.autoid = form.autoid + ''
          form.mautoid = form.mautoid + ''
          form.detail = detail
          Edit_tpr_monthMB(form).then(res => {
            if (res.error == '0') {
              this.$message.success('保存成功')
              this._Query_tpr_monthMB() // 获取列表
              this.showFrom = false
            } else {
              this.$message.error(res.errorinfo)
            }
          })
        } else {
          this.$message.error('请选择项目！')
        }
      } else {
        this.showFrom = false
      }
    },

    action(autoid, type) {
      this.pautoid = autoid
      switch (type) {
        case 1:
          // this.$refs.zb.show = true
          this.choos.name = '上传周报'
          this.$refs.filelist.show = true
          break
        case 2:
          this.choos = { name: '项目调研表' }
          this.$refs.filelist.show = true
          break
        case 3:
          this.choos = { name: '项目上线测试报告' }
          this.$refs.filelist.show = true
          break
        case 4:
          this.choos = { name: '培训签到表' }
          this.$refs.filelist.show = true
          break
        case 5:
          this.choos = { name: '项目验收报告' }
          this.$refs.filelist.show = true
          break

        default:
          break
      }
    },
    closeDialog3() {
      this.jsshow = false
    },
    action2(autoid, type, name) {
      let path = '/main/project/progress'
      let query = {
        autoid: autoid,
        name: name
      }
      this.$router.push({ path: path, query: query })
      // this.show = false
      this.jsshow = true
      Query_tpr_xm_jd({ mautoid: autoid }).then(res => {
        this.tableData2 = res.list.filter(e => {
          console.log(e.status)

          if (type == 1) {
            return ['完成', '完成(延期)'].indexOf(e.status) > -1
          } else if (type == 2) {
            return ['完成', '完成(延期)'].indexOf(e.status) == -1
          } else if (type == 3) {
            return true
          }
        })
      })
    },
    print() {
      GetMBRp({
        yymm: this.yymm,
        crman: this.username
      }).then(res => {
        if (res.error == '0') {
          window.open(res.list[0].ssourl, '_blank')
        } else {
          this.$message.error(res.errorinfo)
        }
      })
    },
    handRowdbClick(row) {
      this.formjd = row
      this.showre = true
      this.$nextTick(() => {
        this.$refs.progressForm.form = JSON.parse(JSON.stringify(row))
      })
    },
    tableCellClassName({ row, column, rowIndex, columnIndex }) {
      console.log(column, columnIndex, row,'tableCellClassName')
      if (columnIndex == 3) {
        // return 'red-cell'
        if (row.ssrt && row.jh_ssrt) {
          if (parseInt(row.ssrt) * 80 > parseInt(row.jh_ssrt) * 80) {
            return 'red-cell'
          }
        }
      }
      // if (row.ssrt && row.jh_ssrt) {
      //   if (parseInt(row.ssrt) * 80 > parseInt(row.jh_ssrt) * 80) {
      //     return 'red-row'
      //   }
      // }
      return ''
    },
    tableRowClassName({ row, rowIndex }) {
      // if (row.ssrt && row.jh_ssrt) {
      //   if (parseInt(row.ssrt) * 80 > parseInt(row.jh_ssrt) * 80) {
      //     return 'red-row'
      //   }
      // }
      return ''
    }
  }
}
</script>

<style scoped lang="scss">
@import '~@/styles/mixin.scss';
.el-dialog__wrapper.monthMBTable {
  color: $font-color;
  /deep/.el-dialog {
    @include wh(99vw, 99vh);
  }
}
.el-dialog__wrapper.jdtable {
  /deep/.el-dialog {
    @include wh(90vw, 99vh);
  }
}
.el-dialog__wrapper.reCHForm {
  color: $font-color;
  /deep/.el-dialog {
    @include wh(1200px, 700px);
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.15);
    .el-dialog__body {
      padding: 20px 20px 0 20px;
      .el-table {
        // 工具栏
        .hidden-columns {
          visibility: inherit;
          z-index: 9999;
          right: 7px;
          // margin-top: 3px;
          .my_tools {
            height: 100%;
            min-width: 45px;
            max-width: 100%;
            // padding: 0 0 0 20px;
            padding: 0 25px 0 20px;
            background: linear-gradient(
              to right,
              rgba(0, 0, 0, 0) 0%,
              #eee 30px,
              #ccc 100%
            );
            position: relative;
            .tools_box {
              @include wh(100%, 100%);
              display: flex;
              align-items: center;
              overflow: auto;
              .el-button {
                // 工具栏 内容字体大小随表单（后台控制）PS：目前只用到button，后期有需要其他再另行补充
                // @include _font;
                width: 100%;
                height: 100%;
                font-size: 12px;
                // display: flex;
                // flex-direction: column;
                // align-items: center;
                svg {
                  display: block;
                  margin: 2px auto;
                }
              }
            }
            // 隐藏按钮
            .hide_btn {
              position: absolute;
              top: 0;
              right: 0;
              @include wh(20px, 100%);
              @include flexCenter;
              border-left: 1px solid transparent;
              transition: all 0.2s;
              &:hover {
                // background: #ccc;
                background: #aaa;
                cursor: pointer;
                // border-left-color: #FFF;
                color: #fff;
              }
            }
          }
          .hide {
            transition: all 0.3s;
            svg {
              transform: rotate(180deg);
            }
          }
        }
      }
    }
  }
}
.el-table {
  /deep/ tr.red-row {
    td {
      background: rgb(255, 132, 132) !important;
    }
  }
  /deep/ td.red-cell {
    background: rgb(255, 132, 132) !important;
  }
}
</style>
